












// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { AssetVersion } from "@/psychlab/types/assets";
import { useAssets } from "@/hooks/useAssets";

import * as AssetAPI from "@/services/api/assets";

// local
// import { useVersionCache } from "../../ts/useVersionCache";

export default defineComponent({

	emits:[],
	props:{
		asset:{
			type:String,
			required:true,
		},
		version:{
			type:String,
			required:true,
		},
		variant:{
			type:String,
			default:"info"
		}
	},
	setup(props){

		const {
			assets
		} = useAssets();

		// const {
		// 	getListRef
		// } = useVersionCache();

		const version = ref<AssetVersion<any>>(); 


		// checkVersion(props.asset, props.version);

		// const versions = ref<AssetVersion<any>[]>([]);

		// const versions = computed(() => {
		// 	return versionCache.getVersionList(props.asset);
		// });

		// const versions = getListRef(props.asset);


		const asset = computed(() => {
			return assets.value.find(a => a._id === props.asset);
		});

		const assetName = computed(() =>{
			return asset.value ? asset.value.name : "";
		});

		const versionLabel = computed(() =>{
			// if(){ return ""; }
			if(!version.value){ return ""; }
			// versionCache.checkVersion(props.asset, props.version);
			// const vr = versions.value.find(v => v._id === props.version);
			// if(!vr){ return ""; }
			return `v${(version.value.vIndex + 1).toString()}`;

		});

		const loadVersionList = async () => {
			version.value = await AssetAPI.getAssetVersion(props.asset, props.version);


			// try {
			// 	versions.value = await versionCache.loadVersionList(props.asset);
			// }catch{}
		};

		loadVersionList();

		return {
			assetName,
			versionLabel,
		};
	}
});

